import React from "react";
import requests from "../Auth/Requests";
import { enqueueSnackbar, closeSnackbar } from "notistack";
import { Box, Paper, Button, TextField, Typography } from "@mui/material";

export default class TestPage extends React.Component {
    state = {
        commands: "",
        jsonBody: "",
        loading: false,
        response: null
    };

    handleInputChange = (e) => {
        this.setState({ commands: e.target.value });
    };

    handleSend = () => {
        const { commands, jsonBody } = this.state;
        if (!commands.trim()) {
            enqueueSnackbar("Please enter a command.", { variant: "warning" });
            return;
        }
        let parsedBody = {};
        if (jsonBody.trim()) {
            try {
                parsedBody = JSON.parse(jsonBody);
            } catch (err) {
                enqueueSnackbar("Invalid JSON in body", { variant: "error" });
                return;
            }
        }
        const key = enqueueSnackbar("Sending...", { variant: "info", persist: true });
        this.setState({ loading: true, response: null });

        requests.request(commands, parsedBody)
            .then(response => {
                closeSnackbar(key);
                enqueueSnackbar("Request successful!", { variant: "success" });
                this.setState({ response: JSON.stringify(response, null, 2), loading: false });
            })
            .catch(error => {
                closeSnackbar(key);
                enqueueSnackbar(`Request failed: ${error.message}`, { variant: "error" });
                this.setState({ response: error.message, loading: false });
            });
    };

    render() {
        return (
            <Box sx={{ padding: 4, maxWidth: 750, margin: "40px auto" }}>
                <Paper sx={{ padding: 3 }}>
                    <Typography variant="h5" gutterBottom>
                        Test Commands
                    </Typography>
                    <TextField
                        label="Commands"
                        value={this.state.commands}
                        onChange={this.handleInputChange}
                        fullWidth
                        multiline
                        minRows={2}
                        sx={{ marginBottom: 2 }}
                        disabled={this.state.loading}
                    />
                    <TextField
                        label="JSON Body"
                        value={this.state.jsonBody}
                        onChange={(e) => this.setState({ jsonBody: e.target.value })}
                        fullWidth
                        multiline
                        minRows={2}
                        sx={{ marginBottom: 2 }}
                        disabled={this.state.loading}
                    />
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={this.handleSend}
                        disabled={this.state.loading}
                    >
                        Send
                    </Button>
                    {this.state.response && (
                        <Paper sx={{ marginTop: 2, padding: 2, backgroundColor: "#f5f5f5" }}>
                            <Typography variant="subtitle1">Response:</Typography>
                            <Typography component="pre" sx={{ whiteSpace: "pre-wrap", wordBreak: "break-all" }}>
                                {this.state.response}
                            </Typography>
                        </Paper>
                    )}
                </Paper>
            </Box>
        );
    }
}